import { Fragment } from 'react';

import Typography from '@/components/typography';

export type TemplateBreadcrumbItem = {
  path: string;
  title: string;
};

type TemplateBreadcrumbProps = {
  breadcrumbs: TemplateBreadcrumbItem[];
};

const TemplateBreadcrumb = ({ breadcrumbs }: TemplateBreadcrumbProps) => {
  //const breadcrumbs = Object.values(props);
  return (
    <div className='w-full'>
      <div className='mb-8 mt-4 flex flex-wrap gap-2'>
        {breadcrumbs.length &&
          breadcrumbs.map((item, index) => (
            <Fragment key={index}>
              <a href={item.path || '#'}>
                <Typography.TextXSmall className='hover:text-typography-dark'>
                  {item.title}
                </Typography.TextXSmall>
              </a>
              {index < breadcrumbs.length - 1 && (
                <Typography.TextXSmall>&gt;</Typography.TextXSmall>
              )}
            </Fragment>
          ))}
      </div>
    </div>
  );
};

export default TemplateBreadcrumb;
